module.exports = __webpack_public_path__ + "static/media/fontSize.27fce295.png";